export var basicRadar = {
    chart: {
        height: 350,
        type: 'radar',
    },
    colors: ['#2f4858'],
    series: [{
        name: 'Series 1',
        data: [80, 50, 30, 40, 100, 20],
    }],
    labels: ['January', 'February', 'March', 'April', 'May', 'June']
}